// src/Auth/AdminProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface AdminProtectedRouteProps {
  element: React.ReactElement;
}

// Check if user is authenticated and is an admin (roleId = 1)
const isAuthenticated = () => !!localStorage.getItem("userid");
const isAdmin = () => localStorage.getItem('roleId') === '1';

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" />;
  }
  
  if (!isAdmin()) {
    toast('You do not have permission to access this page', { type: 'error' });
    return <Navigate to="/dashboard" />;
  }
  
  return element;
};

export default AdminProtectedRoute;
